<template>
  <div class="thumbnail">
    <div v-for="(item, i) in items" class="thumbnail-item" :key="i">
      <div v-if="item.sender === 'robot'" class="pic robot mt-auto mb-auto">
        <i class="fas fa-robot"></i>
      </div>
      <div v-else class="pic user mt-auto mb-auto">
        {{ getInitials(item.sender) }}
      </div>
      <div class="content">
        <span
          ><strong>{{
            item.sender === 'robot' ? 'Sistema' : item.sender
          }}</strong></span
        >
        <textarea
          disabled
          :rows="checkMsgLen(item)"
          :value="checkNotification(item)"
          style="resize: none;"
        />
        <!--
        <span>{{ checkNotification(item) }}</span>
        -->
        <div v-if="item.attachments && item.attachments.length" class="mt-4">
          <a
            style="color: #777777;"
            download
            v-for="(attach, index) in item.attachments"
            :key="index"
            :href="attach"
          >
            <font-awesome-icon
              :icon="['fas', 'paperclip']"
              style="font-size: 16px;"
            />
            Anexo-{{ index + 1 }}
          </a>
        </div>
        <span class="date"
          ><small>{{ dateFormat(item.date) }}</small></span
        >
      </div>
      <div v-if="item.senderId === userId && item.type === 'comment'">
        <a
          v-b-modal="`modal-change-comment-${item._id}`"
          class="fa fa-edit"
          style="color: #4ce595; cursor: pointer;"
        ></a>
      </div>
      <b-modal
        :id="`modal-change-comment-${item._id}`"
        :title="`${$t('treatments.modifyComment')}`"
        ok-title="Salvar"
        cancel-title="Cancelar"
        @ok="updateComment(item._id, item.change)"
      >
        <b-form-textarea
          id="textarea1"
          v-model="item.change"
          :placeholder="`${$t('treatments.comment')}`"
          :rows="3"
          :max-rows="6"
        >
        </b-form-textarea>
      </b-modal>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import axios from 'axios';
import { lightFormat } from 'date-fns';
import * as moment from 'moment';
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';

export default {
  props: ['items'],

  data: () => ({
    userAuth: null,
    userId: null,
    token: null,
    answerId: null,
    branchName: null,
  }),

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.userId = this.userAuth._id;
    this.token = this.userAuth.token;
    const wl = `${window.location}`;
    const wl2 = wl.split('/');
    this.answerId = wl2[wl2.length - 1];
  },

  methods: {
    checkMsgLen(item) {
      if (item.change) {
        return item.change.split('\n').length + 1;
      }
      return 0;
    },
    checkNotification(item) {
      if (item.type === 'alert') {
        return this.$t('treatments.alertEmail', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'status') {
        return this.$t('treatments.statusUpdate', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'addcategory') {
        return this.$t('treatments.answerCategory', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'rmcategory') {
        return this.$t('treatments.removedCategory', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'comment') {
        return this.$t('treatments.newComment', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'responsible') {
        return this.$t('treatments.responsibleDealt', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'manual-answer') {
        return this.$t('treatments.responseCollected', {
          itemChange: `${item.change}`,
        });
      } else if (item.type === 'resurvey') {
        return this.$t('treatments.resurveySubmitted');
      } else if (item.type === 'resurvey-scheduled') {
        return this.$t('treatments.resurveyScheduled');
      } else if (item.type === 'removeanswer') {
        return this.$t('treatments.removedAnswer');
      } else if (item.type === 'restoreanswer') {
        return this.$t('treatments.restoredAnswer');
      } else if (item.type === 'transfer') {
        return 'Resposta transferida para filial';
      } else if (item.type === 'transfer-action') {
        return 'Resposta transferida para outra ação';
      } else if (item.type === 'scaling-level1') {
        return `Tratativa escalonada N1 para: ${item.change}`;
      } else if (item.type === 'scaling-level2') {
        return `Tratativa escalonada N2 para: ${item.change}`;
      } else if (item.type === 'scaling-level3') {
        return `Tratativa escalonada N3 para: ${item.change}`;
      } else if (item.type === 'revision-status') {
        return this.$t('treatments.statusUpdate', {
          itemChange: `${item.change}`,
        })
      } else if (item.type === 'status-treatment') {
        const isScheduling = item.schedulingDate ? true : false;
        return `Registro de contato alterado para: ${item.change} ${
          isScheduling
            ? `\n Agendado para: ${moment(item.schedulingDate)
                .add(3, 'hours')
                .format('DD/MM/YYYY HH:mm')}`
            : ''
        }`;
      } else if(item.type === 'revision-treatment') {
        return `Pedido de revisão: \n${item.change}`

      } else if(item.type === 'autopilot') {
        return `${item.change}`

      }

      return this.$('treatments.system');
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'H:mm');
      return `${day} às ${hour}`;
    },

    getInitials(item) {
      if (item) {
        const names = item.split(' ');

        if (names.length === 1) {
          return `${names[0].charAt(0)}`.toUpperCase();
        }
        return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
      }

      return '-';
    },

    async updateComment(id, comment) {
      try {
        await axios.patch(
          `${process.env.API_ROOT}/treatments/comment/${this.answerId}`,
          { commentId: id, comment },
          { headers: { 'x-access-token': this.token } },
        );
        swal({
          title: this.$('treatments.messages.updateComment.title'),
          text: this.$('treatments.messages.updateComment.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$('treatments.messages.errorUpdateComment.title'),
          text: this.$('treatments.messages.errorUpdateComment.description'),
          icon: 'error',
        });
      }
    },
  },

  computed: {
    ...mapFields('treatments', ['fromDetails', 'oneAnswer']),
    ...mapState('treatments', ['answer']),
    ...mapFields('alertRules', ['branchItems', 'loadingBranches']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/placeholders.scss';

.thumbnail {
  max-height: 520px;
  min-height: 520px;
  overflow: auto;
}

.thumbnail-item {
  display: flex;
  flex-direction: row;
  padding: 15px 0;
  border-bottom: 1px solid rgb(240, 236, 236);
  &:last-child {
    border-bottom: 0;
  }
}

.pic {
  width: 45px;
  height: 45px;
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.robot {
  border: 2px solid $primary;
  color: $primary;

  i {
    font-size: 1.25em;
  }
}

.user {
  background-color: $primary;
  color: $white;
  font-weight: bold;
}

.content {
  padding: 0 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.date {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatment-feed-item/index.vue